<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" titulo="Servicios" style="flex: 1 0 100%" />
    <div slot="contenido">
      <div class="tarjetario">
        <SeguroSaludHNAServicios v-if="visibleSeguroSaludHNA" class="tarjeta" />
        <AsistenciaAuto v-if="visibleAsistenciaAuto" class="tarjeta" />
        <AsistenciaHogar v-if="visibleAsistenciaHogar" class="tarjeta" />
        <ServiciosDecesosPremium v-if="visibleServiciosDecesosPremium" class="tarjeta" />
        <SubsidioParalizacion v-if="visibleSubsidioParalizacion" class="tarjeta" />
        <TallerCRM v-if="visibleTallerCRM" class="tarjeta" />
        <Carglass v-if="visibleCarglass" class="tarjeta" />
        <TalleresCalidadPremium v-if="visibleTalleresCalidadPremium" class="tarjeta" />
        <AsesoramientoJuridico v-if="visibleAJT" class="tarjeta" />
        <DeclararSiniestro v-if="visibleDeclararSiniestro" class="tarjeta" />
      </div>
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {

    visibleSeguroSaludHNA() {
      return this.$store.state.portfolio.tienePolizaSaludHNA == "S";
    },

    visibleAsistenciaAuto() {
      return this.$store.state.portfolio.tienePolizaConAv == "S";
    },

    visibleAsistenciaHogar() {
      return this.$store.state.portfolio.tienePolizaConAsistenciaHogar == "S";
    },

    visibleTallerCRM() {
      const tienePolizaAutos =
        this.$store.state.portfolio.tienePolizaAutos == "S";
      const esPuroMMT = this.$store.state.portfolio.cliente.purezaPuroMMT;
      const esMadrid =
        this.$store.state.portfolio.cliente.codPostal.substring(0, 2) == "28";
      return tienePolizaAutos && esPuroMMT && esMadrid;
    },

    visibleTalleresCalidadPremium() {
      const tienePolizaAutos =
        this.$store.state.portfolio.tienePolizaAutos == "S";
      return tienePolizaAutos;
    },

    visibleAJT() {
      return this.$store.state.portfolio.tienePolizaConAjt == "S";
    },

    visibleDeclararSiniestro() {
      return (
        this.$store.state.portfolio.tienePolizaMoto == "S" ||
        this.$store.state.portfolio.tienePolizaAutos == "S"
      );
    },
    visibleServiciosDecesosPremium() {
      return this.$store.state.portfolio.tienePolizaDecesosPremium;
    },
    visibleSubsidioParalizacion() {
      return this.$store.state.portfolio.cuantasPolizasConSubsidio > 0;
    },
    visibleCarglass() {
      return this.$store.state.portfolio.tienePolizaConLunas == "S";
    },
  },
};
</script>
